import styled from 'styled-components';
import Button from 'react-bootstrap/Button';

export const Wrapper = styled.div`
  position: fixed;
  z-index: 1000;
  bottom: 10px;
  left: 10px;
  padding: 24px;
  width: 360px;
  background-color: #fff;
  box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
  border-radius: 10px;
  font-family: OpenSans, sans-serif;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.01em;
`

export const H5 = styled.h5`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #2C2B48;
`

export const Content = styled.div`
  margin-bottom: 14px;
`

export const Icon = styled.img`
  transition: ease-in-out 0.8s;
  &.rotate{
    transform: rotateX(180deg);
  }
`

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ManageBtn = styled(Button)`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 115%;
  background-color: #fff;
  border: none;
  padding: 0;
  color: #0039BB;
  &:hover, &:focus, &:active {
    background-color: #fff;
    color: #0039BB;
    border-width: 0;
    box-shadow: none;
  }
`

export const AcceptBtn = styled(Button)`
  font-family: Manrope, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 115%;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
  border-radius: 4px;
  border-width: 0;
  padding: 7px 15px;

  &:hover{
    background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    border-width: 0;
  }
  &:focus{
    border-width: 0;
    background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
  }
`

export const OptionsContainer = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: ease-in-out 0.2s;
  &.open{
    padding-top: 30px;
    max-height: 690px;
  }
`

export const Option = styled.div`
  margin-bottom: 20px;
`

export const OptionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 5px;
`

export const Highlight = styled.span`
  color: #EF1C62;
  font-size: 12px;
  font-weight: 500;
`

export const Checkbox = styled.img`
  
`

export const Explanation = styled.div`
  font-family: OpenSans, sans-serif;
  font-size: 12px;
  font-weight: 400;
`